import React, { useState } from 'react';

const SearchTnaProduct = ({ handleSearch, searchValue }) => {
	const [showSearch, setShowSearch] = useState(false);
	return (
		<form className="form-group size32 m-0 mr-3 search-filter filter-with-animation">
			<div className="with-icon right-icon">
				{showSearch && (
					<input
						type="text"
						placeholder="Search style"
						autoFocus
						name="searchStyle"
						autoComplete="off"
						value={searchValue}
						onChange={(e) => handleSearch(e.target.value)}
					/>
				)}
				<span className="right-icon" onClick={() => setShowSearch((prev) => !prev)}>
					<img
						src={`${process.env.PUBLIC_URL}/icons/search-dark.svg`}
						alt=""
						className="item-image"
					/>
				</span>
			</div>
		</form>
	);
};

export default SearchTnaProduct;
